import RachelDropOverlayView from './RachelDropOverlayView';
import { useRachelDropOverlay } from './useRachelDropOverlay';

const RachelDropOverlay = () => {
  const { hasOwnBorder, hasInlineBleed } = useRachelDropOverlay();

  return <RachelDropOverlayView hasOwnBorder={hasOwnBorder} hasInlineBleed={hasInlineBleed} />;
};

export default RachelDropOverlay;
